import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputCombo from "../../helpers/InputCombo";
import InputDateMulti from "../../helpers/InputDateMulti";
import InOutNew from "./InOutNew";



function NoRegister(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [tab,setTab] = useState([]);
    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzien:  "",
        dni:  "",
        godzina: "",
        operacja: "I",
        fraza: '',
        p_dziecko_id: '',
        powod: "",     
    });



    const valChangeListener = (filedName, val, correct, msg) => {

      //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     

        var sp = filedName.split("@");

        if(sp.length > 2)
        {
            var dzien = sp[0];
            var dzId = parseInt( sp[1]);
            var operacja = sp[2]; // I / O 

        
            var tmp = JSON.parse( JSON.stringify(tab) );

            for(var d=0; d < tmp.length; d++)
            {
                if(tmp[d].dzien == dzien)
                {              
                    for(var n=0; n < tmp[d].nz.length; n++)
                    {
                     //   console.log("EE ",dzien, dzId,operacja, n, tmp[d].nz[n] );
                         
                            if(tmp[d].nz[n].id == dzId  && operacja == 'IN' )
                            {
                                    tmp[d].nz[n].h_in = val;
                                    break;
                            }
                            if(tmp[d].nz[n].id == dzId  && operacja == 'OUT' )
                                {
                                    tmp[d].nz[n].h_out = val;
                                    break;
                                }
                    }
                    break;
                }
            }

            setTab(tmp);
            return;
        }


       // setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const kidSelected = (p_dziecko_id) => {

 

        setRow( {...row, ['p_dziecko_id']:p_dziecko_id  } );
    }



    const saveData = (e) => {


        e.target.innerHTML = "czekaj...";
 
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_kids,inout_no_register_update', {
            method: 'POST', 
            body: JSON.stringify({
                days: tab
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();
                    props.onSuccess();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Dane został zapisane" , "ok" , null);                                             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {

        setRow({
            dzien:  "",
            godzina: "",
            fraza: '',
            operacja: "I",
            p_dziecko_id: '',
            powod: "",  
        });
            
            if(view == 'btn')
                 {
                    setView("dlg");

                    setTimeout(() => {
                        getTab();
                    }, 40);

                    
                 }  
                 else
                 { 
                    setView('btn');
                    setTab([]);
                 }
    }     





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,inout_no_register', {
            method: 'POST', 
            body: JSON.stringify([]), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    



    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setView('btn');
        }


    var opType = [
        {
            v:"I",
            title: 'Wejście'
        },
        {
            v:"O",
            title: 'Wyjście'
        },        
    ];
 


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Lista niezarejestrowanych wejść i wyjść (30 dni wstecz)
                    </div>


                    <div className="dlg_content_x">
 
                            <div className="scroll200">
                                
                                    <table className="table" >
 
                                        <tbody>

                                              {
                                                tab.map( (kids,ix) => {

                                                    return <Fragment>

                                                            {
                                                                kids.nz.map( (item, ix) => {

                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";
                
                                                                    var inMsg = null;
                                                                    var outMsg = null;


                                                                    if(item.is_in == 0)   inMsg = <span>
                                                                        Wejscie: 
                                                                        <InputTime   userData={props.userData} value={item.h_in} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={kids.dzien+"@"+item.id+"@IN"} placeholder={"Godzina: "} className=' w100 ' req='0' firstUp="0" />
                                                                    </span>


                                                                    if(item.is_out == 0)  outMsg = <span>
                                                                        Wyjście:
                                                                        <InputTime   userData={props.userData} value={item.h_out} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={kids.dzien+"@"+item.id+"@OUT"} placeholder={"Godzina: "} className=' w100 ' req='0' firstUp="0" />
                                                                    </span>

                                                                    return <tr className={rowStyle} >
                                                                            <td className="gocenter">{ix+1}</td>
                                                                            <td className="gocenter">{kids.dzien}</td>  
                                                                            <td className="gocenter">{item.nazwisko + " " + item.imie}</td>  
                                                                            <td className="gocenter">{inMsg}</td>    
                                                                            <td  className="td_right">{outMsg}</td>                                                                                                                                                                                                                                 
                                                                    </tr>
                                                                    
                                                                } )
                                                            }

                                                    </Fragment>    

                                                  
                                                } )
                                              }  

                                        </tbody>

                                    </table>                            
                                 
                            </div>

                            <br/> 
                            <div>
                                <span className="btn" onClick={changeView} >zamknij</span>
                                &nbsp;
                                <span className="btn" onClick={saveData} >zapisz</span>
                            </div>
                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;



    return  <div className="inline_block">
                <div className="btn"    onClick={changeView} >pokaż niezarejestrowane</div> 
                {dlg_view} 
           </div>
}


export default NoRegister;